import React, { useState } from 'react'
import AdminLayout from '../../../layouts/AdminLayout'
import { Container } from 'react-bootstrap'
import MenuTabsComponent from '../components/MenuTabsComponent'
import DashboardReportComponent from '../components/DashboardReportComponent'
import OccupancyReportComponent from '../components/OccupancyReportComponent'
import AgentReportComponent from '../components/AgentReportComponent'
import RevenueReportComponent from '../components/RevenueReportComponent'
import SalesReportComponent from '../components/SalesReportComponent'
import RequireAuth from '../../../auth/middleware/RequireAuth'
import HousekeepingForecastReportComponent from '../components/HousekeepingForecastReportComponent'
import PaymentReportComponent from '../components/PaymentReportComponent'
import BreakfastReportComponent from '../components/BreakfastReportComponent'
import ExtraReportComponent from '../components/ExtraReportComponent'
// import HousekeepingForecastReportComponent from '../components/HousekeepingForecastReportComponent'
// import TransactionsTypeReportComponent from '../components/TransactionsTypeReportComponent'
// import PaymentReportComponent from '../components/PaymentReportComponent'

const DashboardReport: React.FC = () => {
    const [activeTab, setActiveTab] = useState("dashboard");

    return (
        <AdminLayout>
            <div className="container-fluid">
                <Container className="my-4" fluid>
                    <MenuTabsComponent activeTab={activeTab} onTabChange={setActiveTab} />
                </Container>

                {activeTab === "dashboard" && (
                    <RequireAuth requiredRoles={['dev']} requiredPermissions={['pms_report_view']} asComponent>
                        <DashboardReportComponent />
                    </RequireAuth>
                )}
                {activeTab === "occupancy" && (
                    <RequireAuth requiredRoles={['dev']} requiredPermissions={['pms_report_occupancy_report']} asComponent>
                        <OccupancyReportComponent />
                    </RequireAuth>
                )}
                {activeTab === "agent" && (
                    <RequireAuth requiredRoles={['dev']} requiredPermissions={['pms_report_agent_report']} asComponent>
                        <AgentReportComponent />
                    </RequireAuth>
                )}
                {activeTab === "revenue" && (
                    <RequireAuth requiredRoles={['dev']} requiredPermissions={['pms_report_revenue_report']} asComponent>
                        <RevenueReportComponent />
                    </RequireAuth>
                )}
                {activeTab === "sales" && (
                    <RequireAuth requiredRoles={['dev']} requiredPermissions={['pms_report_sales_report']} asComponent>
                        <SalesReportComponent />
                    </RequireAuth>
                )}
                {activeTab === "payment" && (
                    <RequireAuth requiredRoles={['dev']} requiredPermissions={['pms_report_payment_report']} asComponent>
                        <PaymentReportComponent />
                    </RequireAuth>
                )}
                {activeTab === "breakfast" && (
                    <RequireAuth requiredRoles={['dev']} requiredPermissions={['pms_report_breakfast_report']} asComponent>
                        <BreakfastReportComponent />
                    </RequireAuth>
                )}
                {activeTab === "extra" && (
                    <RequireAuth requiredRoles={['dev']} requiredPermissions={['pms_report_extra_report']} asComponent>
                        <ExtraReportComponent />
                    </RequireAuth>
                )}
                {/* {activeTab === "transaction_type" && (
                    <RequireAuth requiredRoles={['dev']} requiredPermissions={['pms_report_transaction_type_report']} asComponent>
                        <TransactionsTypeReportComponent />
                    </RequireAuth>
                )} */}
                {activeTab === "housekeeping_forecast" && (
                    <RequireAuth requiredRoles={['dev']} requiredPermissions={['pms_report_housekeeping_forecast_report']} asComponent>
                        <HousekeepingForecastReportComponent />
                    </RequireAuth>
                )}
            </div>
        </AdminLayout>
    )
}

export default DashboardReport